import type { CanvasShapeOption } from '../types'

export const CANVAS_SHAPE_OPTIONS: ReadonlyArray<{
  value: CanvasShapeOption
  label: string
}> = [
  { value: 'round', label: 'Rectangle' },
  { value: 'circle', label: 'Circle' },
] as const

export const DEFAULT_CANVAS_SHAPE: CanvasShapeOption = 'round'
